import { LoaderCircleIcon } from "lucide-react"
import { lazy, Suspense } from "react"

const getLazy = (
  // biome-ignore lint/suspicious/noExplicitAny: No easy way to avoid any here.
  importFunc: () => Promise<{ default: React.ComponentType<any> }>,
) => {
  const LazyComponent = lazy(importFunc)
  return function WrappedLazyComponent() {
    return (
      <Suspense
        fallback={
          <LoaderCircleIcon
            height={64}
            className="text-primary mt-32 w-full animate-spin"
          />
        }
      >
        <LazyComponent />
      </Suspense>
    )
  }
}

export default getLazy
